const DataObjectsTemplate = [
        {dataType: "activityScore", score: {type: "", points: 0, nbrIncorrect: 0, gamesRemaining: 0, 
                nbrAttempted: 0, maxScore: 0, newLevelEarned: false, 
                timeRemaining: {minutes: 0, seconds: 0}}},
        {dataType: "activityTracker", activityInfo: {activityName: "", nbrTimesPlayed: "",
                lastTimePlayed: "", level: ""}},
        {dataType: "friendList", friendInfo: {name: "", introDate: "",  dialogIndx: "firstTime", rltnshpScore: "0",
                totalLoanAmt: "0"}},
        {dataType: "creditCardInfo", creditInfo: {gameID: "", paymentPolicyCode: "", currentlyActive: false,
                creditCardStartDate: "", cardLevel: "", creditMaxAmount: "", totalOutstandingBalance: "0.00",
                totalIntBilled: "", lateFeeCount: "0", periodCreditCharges: []
        }},
        {dataType: "periodCreditCharges", creditInfo: {bgnDate: "", endDate: "", periodBilledAmt: 0,
                periodMinAmt: 0, periodAmtPaid: 0, periodIntAmt: 0, periodLateFee: 0, creditChargesArr: []}},
        {dataType: "spendingHistory", spendingHistoryInfo: {currentMonthSpendAmt: 0, current10YearSpendAmt: 0,
                current10YearMonths: 0, previous10YearSpendAmt: 0, previous10YearMonths: 0}},
        {dataType: "moodPointHistory", moodPointHistoryInfo: {currentMonthMoodPoints: 0, totalMoodPoints: 0, 
                moodPointMonths: 0}},
        {dataType: "eventsHeader", eventHeaderInfo: {title: "", description: "", frequency: "", 
                conditionConnector: "", conditionArr: [], skipConditionArr: [], backgroundType: "",
                imageDir: "", careerTag: "", selectMonthArr: [], gamePhase: "", eventCategory: "",
                dateCreated: "", dateAdded: "", dateUpdated: "", responses: [], frequencyObj: ""
        }},
        {dataType: "eventPossibleEffects", possibleObj: {category: "", closureText: "", on: "",
                type: "", duration: "", odds: "", replaceAmtSw: "", triggerCondition: "", 
                deleteCondition: "", deleteClass: "",  moodPoints: "", possibleValues: []
        }},
        {dataType: "eventResponse", btnText: "", category:"cash", closureText:"", deleteClass:"",
                deleteCondition:"", duration:"1", itemDesc:"", moodPoints:"", on:"cash",
                replaceAmtSw:false, rltnshpScore:"", triggerCondition:"", type:"flat", value:""},
        {dataType: "timeWizardInfo", timeWizardInfo: {gameID: "", status: "", level: "", gameDate: "", nbrGameMonths: "",
                nbrMonthsPerTurn: "", gameNbrYears: "", dateAdded: "", dateUpdated: ""}},
        {dataType: "investTransaction", investTransObj: {investShortName: "", transNbr: "0", quantity: "0", 
                tranType: "", transactionDate: "yyyy-mm", transactionGameMonth: "", unitPrice: ""}},
        {dataType: "investHistoryTransaction", investTranObj: { investShortName: "",  tranType: "",
                quantity: 0, dateBought: "", dateClosed: "", buyPrice: "",  buyAmount: "", 
                sellPrice: "", sellAmount: "", totalGainLoss: "", transNbr: 0}},
        {dataType: "savingsArrObj", savingsInfo: { 
                savingsType: "0",  monthlyDepositAmt: "0", 
                yearArr: [], startDate: "", closedDate: "", savingTotals: {}, savingsClass: "",
                taxHistoryArr: []}
        },
        {dataType: "savingsArrObjBank", savingsInfo: {interestRate: "0", intRateStartDate: "0"}},
        {dataType: "savingsInfoObj", savingsInfo: {currentlyActive: false, totalSavings: 0,
                savingsArr: [], dateAdded: "", dateUpdated: "", companyMatchRate: "0", level: 0
        }},
        {dataType: "savingTotals", totalSavings: 0, totalDeposit: 0, totalInterest: 0,
                totalTransfer: 0, totalTransferFee: 0, totalMatchDeposits: 0,
                totalShareQty: 0, totalMatchQty: 0}
 
]
 
export default DataObjectsTemplate;